import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { colspan: "12" }
const _hoisted_2 = { style: {"white-space":"nowrap"} }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "text-left" }
const _hoisted_5 = { class: "text-left" }
const _hoisted_6 = { class: "text-right" }
const _hoisted_7 = { class: "text-right" }
const _hoisted_8 = { class: "text-right" }
const _hoisted_9 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_oss_text_field = _resolveComponent("oss-text-field")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_oss_date_range_picker = _resolveComponent("oss-date-range-picker")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!
  const _component_DocumentWizardDialog = _resolveComponent("DocumentWizardDialog")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createElementBlock("div", {
    key: _ctx.key,
    class: "ma-3"
  }, [
    _createVNode(_component_v_row, { class: "d-flex mb-2" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "2" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn_primary, {
              block: "",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addZTillDialog = true)),
              size: "large"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("ztill.ajouter")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "2",
          class: "px-1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              style: {"background-color":"#fff","border-radius":"15px"},
              class: "mx-1",
              "no-gutters": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_oss_text_field, {
                      modelValue: _ctx.minAmount,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.minAmount) = $event)),
                      label: "Min",
                      color: "secondary",
                      min: "0",
                      "hide-details": ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "1",
                  class: "d-flex align-center justify-end"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { size: "7px" }, {
                      default: _withCtx(() => _cache[12] || (_cache[12] = [
                        _createTextVNode("$oss-chevron-left")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_oss_text_field, {
                      modelValue: _ctx.maxAmount,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.maxAmount) = $event)),
                      label: "Max",
                      color: "secondary",
                      min: "0",
                      "hide-details": ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "2",
          class: "px-1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_select, {
              outlined: "",
              label: _ctx.$t('ztill.period'),
              modelValue: _ctx.period,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.period) = $event)),
              items: _ctx.allZtillPeriods,
              "item-value": "value",
              "item-title": "title",
              "hide-details": "",
              density: "compact"
            }, null, 8, ["label", "modelValue", "items"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "3",
          class: "px-1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_oss_date_range_picker, {
              begin: _ctx.beginDate,
              end: _ctx.endDate,
              "bg-color": "white",
              "hide-details": "",
              dense: "",
              onChangeDateRange: _ctx.onDateRangeChanged
            }, null, 8, ["begin", "end", "onChangeDateRange"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "1",
          class: "d-flex align-center px-1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn_icon, {
              icon: "$delete",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.clearFilter())),
              color: "secondary"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_data_table_server, {
      items: _ctx.items,
      page: _ctx.pagination.page,
      "sort-by": _ctx.pagination.sortBy,
      "sort-desc": _ctx.pagination.descending,
      "items-per-page": _ctx.pagination.rowsPerPage,
      "items-length": _ctx.pagination.totalItems,
      "items-per-page-options": [5, 10, 25],
      loading: _ctx.loading,
      class: "table",
      "hide-default-footer": "",
      "fixed-header": "",
      height: "70vh",
      style: {"min-width":"800px"}
    }, {
      headers: _withCtx(() => [
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_1, [
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "d-flex justify-end"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "5",
                  class: "d-flex justify-end align-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.pagination.rowsPerPage,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.pagination.rowsPerPage) = $event)),
                      items: [5, 10, 25],
                      "hide-details": "",
                      outlined: "",
                      style: {"font-size":"0.75rem","width":"min-content"},
                      width: "30px",
                      prefix: "Lignes par page",
                      density: "compact"
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("span", _hoisted_2, _toDisplayString((_ctx.pagination.page - 1) * _ctx.pagination.rowsPerPage + 1) + " - " + _toDisplayString((_ctx.pagination.page - 1) * _ctx.pagination.rowsPerPage +
                                        _ctx.pagination.rowsPerPage) + " de " + _toDisplayString(_ctx.pagination.totalItems), 1),
                    _createVNode(_component_v_btn_prev, {
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.pagination.page--)),
                      disabled: _ctx.pagination.page === 1,
                      size: "small"
                    }, null, 8, ["disabled"]),
                    _createVNode(_component_v_btn_next, {
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.pagination.page++)),
                      size: "small",
                      disabled: _ctx.nextPageDisabled
                    }, null, 8, ["disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ])
      ]),
      "no-data": _withCtx(() => [
        _createVNode(_component_v_row, {
          class: "py-3",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.addZTillDialog = true))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              class: "d-flex justify-center"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("ztill.aucun")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              class: "py-3"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn_primary, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("ztill.ajouter")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      item: _withCtx(({ item }) => [
        _createElementVNode("tr", {
          style: {"cursor":"pointer"},
          onClick: ($event: any) => (_ctx.openTicketZ(item))
        }, [
          _createElementVNode("td", _hoisted_4, [
            _createVNode(_component_v_icon, {
              color: "secondary",
              size: "small"
            }, {
              default: _withCtx(() => _cache[13] || (_cache[13] = [
                _createTextVNode("$oss-calendar")
              ])),
              _: 1
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.getSubTitle(item)) + " ", 1),
            (_ctx.haveFile(item))
              ? (_openBlock(), _createBlock(_component_v_icon, {
                  key: 0,
                  color: "primary",
                  class: "spacer-left-small",
                  size: "small"
                }, {
                  default: _withCtx(() => _cache[14] || (_cache[14] = [
                    _createTextVNode("$oss-paper-clip")
                  ])),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (item.uniqueExport && item.uniqueExport.id)
              ? (_openBlock(), _createBlock(_component_v_icon, {
                  key: 1,
                  color: "secondary",
                  class: "spacer-left-small",
                  size: "small"
                }, {
                  default: _withCtx(() => _cache[15] || (_cache[15] = [
                    _createTextVNode("$oss-download")
                  ])),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.getDateFormated(item)), 1),
          _createElementVNode("td", _hoisted_6, " HT: " + _toDisplayString(_ctx.newCommonFormatCurrency(item.netAmount, undefined)), 1),
          _createElementVNode("td", _hoisted_7, " TVA : " + _toDisplayString(_ctx.newCommonFormatCurrency(item.vatAmount, undefined)), 1),
          _createElementVNode("td", _hoisted_8, [
            _createElementVNode("b", null, _toDisplayString(_ctx.newCommonFormatCurrency(item.grossAmount, undefined)), 1)
          ]),
          _createElementVNode("td", _hoisted_9, [
            (_ctx.enableDelete(item))
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  color: "white",
                  icon: "$delete",
                  onClick: _withModifiers(($event: any) => (((_ctx.zTillToDelete = item), (_ctx.deleteDialog = true))), ["stop"])
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ], 8, _hoisted_3)
      ]),
      _: 1
    }, 8, ["items", "page", "sort-by", "sort-desc", "items-per-page", "items-length", "loading"]),
    (_ctx.addZTillDialog)
      ? (_openBlock(), _createBlock(_component_DocumentWizardDialog, {
          key: 0,
          modelValue: _ctx.addZTillDialog,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.addZTillDialog) = $event)),
          companyId: _ctx.selectedCompany.id,
          showFirstPrevious: false,
          inGlobalStep: 'zTillReceipt',
          onCreated: _ctx.onZTillReceiptCreated
        }, null, 8, ["modelValue", "companyId", "onCreated"]))
      : _createCommentVNode("", true),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.deleteDialog,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.deleteDialog) = $event)),
      title: "Supprimer",
      error: true,
      onClose: _cache[11] || (_cache[11] = ($event: any) => (_ctx.zTillToDelete = null)),
      onValid: _ctx.deleteZTill,
      validLoading: _ctx.deleteLoading,
      width: "800px"
    }, {
      default: _withCtx(() => _cache[16] || (_cache[16] = [
        _createElementVNode("h4", { class: "text-center" }, "Êtes-vous sûr(e) de vouloir supprimer ce z de caisse ?", -1)
      ])),
      _: 1
    }, 8, ["modelValue", "onValid", "validLoading"])
  ]))
}